export enum DasStatusCode {
  NV_DAS_SUCCESS = 'NV_DAS_SUCCESS',
}
